var _svg;
import * as React from 'react';

/**
 * @ignore - internal component.
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function LineIcon() {
  return _svg || (_svg = /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 377.8 377.8",
    height: "24",
    width: "24",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#00C300",
      fillRule: "evenodd",
      d: "M77.3 0h223.1a77.5 77.5 0 0 1 77.4 77.3v223.1a77.5 77.5 0 0 1-77.4 77.4h-223A77.5 77.5 0 0 1 0 300.4v-223A77.5 77.5 0 0 1 77.3 0z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#FFF",
      fillRule: "evenodd",
      d: "M188.5 62.6c76.6 0 138.6 49.7 138.6 111A94.8 94.8 0 0 1 304 235l-.1.1a119 119 0 0 1-15.1 15c-38.3 35.5-101.4 77.6-109.7 71.1-7.3-5.6 11.9-33.3-10.2-37.9l-4.6-.6C99.3 273.5 50 228.1 50 173.5c0-61.3 62-111 138.6-111z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#00C300",
      fillRule: "evenodd",
      d: "M108.1 209h28c4 0 7.2-3.3 7.2-7.3v-.6c0-4-3.3-7.2-7.2-7.2h-20.2V148c0-4-3.2-7.2-7.2-7.2h-.6c-4 0-7.2 3.2-7.2 7.2v53.6c0 4 3.2 7.3 7.2 7.3zm173.2-33.6v-.7c0-4-3.2-7.2-7.2-7.2H254v-11.4h20c4 0 7.3-3.3 7.3-7.3v-.6c0-4-3.2-7.2-7.2-7.2h-28c-4 0-7.2 3.3-7.2 7.2V202c0 4 3.3 7.2 7.2 7.2h28c4 0 7.2-3.3 7.2-7.2v-.7c0-4-3.2-7.2-7.2-7.2H254v-11.4h20c4 0 7.3-3.3 7.3-7.2zm-53.7 31.4a7.2 7.2 0 0 0 2-5V148c0-4-3.2-7.2-7.2-7.2h-.6c-4 0-7.2 3.2-7.2 7.2v31.5l-26.1-35a7.2 7.2 0 0 0-6.3-3.7h-.6c-4 0-7.2 3.2-7.2 7.2v53.6c0 4 3.2 7.3 7.2 7.3h.6c4 0 7.2-3.3 7.2-7.3v-32l26.3 36 .6.6a6 6 0 0 0 2.8 2.1 6 6 0 0 0 2.7.6h.6a7.2 7.2 0 0 0 3.4-.9 5 5 0 0 0 1.8-1.3zm-71.3 2.2h.6c4 0 7.3-3.3 7.3-7.3v-53.6c0-4-3.3-7.2-7.3-7.2h-.6c-4 0-7.2 3.2-7.2 7.2v53.6c0 4 3.3 7.3 7.2 7.3z",
      clipRule: "evenodd"
    })]
  }));
}